import { useSearchParams } from 'react-router-dom';

export const useGetSearchParams = () => {
  const [searchParams] = useSearchParams();
  const hspId = searchParams.get('hspId');
  const acptNo = searchParams.get('acptNo');
  const ccrcGuidId = searchParams.get('ccrcGuidId');
  const hspCd = searchParams.get('hspCd');
  const ptMpiKey = searchParams.get('ptMpiKey');
  const fileDataType = searchParams.get('fileDataType');
  const redirectUrl = searchParams.get('redirectUrl');

  return { hspId, acptNo, ccrcGuidId, hspCd, ptMpiKey, fileDataType, redirectUrl };
};
